import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Breast Augmentation Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Dermatology, Fellowship in Cosmetic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cosmetic Breast Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Breast Augmentation Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship in Aesthetic Medicine",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Natural Breast Enhancement Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Mommy Makeover Breast Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cosmetic Breast Surgery Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Breast Augmentation Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for natural-looking breast enhancement with personalized implant selection and rapid recovery.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const BreastAugmentationSurgery = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Breast Augmentation Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Natural-looking Breast Enhancement with 99% Patient Satisfaction. Personalized Implant Selection with Minimal Scarring.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Breast Reconstruction Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>99%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-2</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>4-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Full Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<1%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "benefits", label: "Benefits", icon: "🔍" },
              { id: "types", label: "Implant Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Breast Augmentation Surgery</span>
            </h2>
          </div>

          {/* What is Breast Augmentation */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Breast Augmentation
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Breast augmentation, also known as augmentation mammoplasty, is a cosmetic surgical procedure 
                designed to enhance breast size and shape using implants or fat transfer. This procedure helps 
                women achieve their desired breast contour, improve symmetry, and restore breast volume lost 
                due to weight reduction or pregnancy.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Women seeking to enhance breast size, restore volume after pregnancy/breastfeeding, 
                      improve breast symmetry, or reconstruct breasts after mastectomy or injury.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Natural Results</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Modern techniques focus on creating natural-looking results that complement your 
                      body proportions, with implants placed to achieve optimal shape and projection.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits & Advantages */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Benefits & Advantages
            </h3>

            <div className="row">
              {[
                {
                  title: "Enhanced Confidence", 
                  description: "Improved self-esteem and body image with better-proportioned breast contours",
                  details: "Psychological benefits and increased comfort in clothing"
                },
                {
                  title: "Natural Appearance", 
                  description: "Customized implant selection for results that look and feel natural",
                  details: "Personalized approach based on body type and goals"
                },
                {
                  title: "Volume Restoration", 
                  description: "Restores breast volume lost due to pregnancy, breastfeeding, or weight loss",
                  details: "Recreates youthful breast fullness and shape"
                },
                {
                  title: "Improved Symmetry", 
                  description: "Corrects asymmetrical breasts for balanced appearance",
                  details: "Custom sizing for each breast if needed"
                },
                {
                  title: "Clothing Fit", 
                  description: "Better fitting clothes and swimwear with enhanced bust line",
                  details: "Increased options in fashion choices"
                },
                {
                  title: "Long-lasting Results", 
                  description: "Permanent enhancement with implants designed for durability",
                  details: "Modern implants with excellent longevity"
                }
              ].map((benefit, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {benefit.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {benefit.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {benefit.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Implant Types & Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Implant Types & Options
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Silicone Gel Implants",
                    description: "Most popular choice with natural feel, cohesive gel that maintains shape if ruptured",
                    treatment: "Pre-filled with silicone gel, various shapes and profiles available"
                  },
                  {
                    type: "Saline Implants",
                    description: "Filled with sterile salt water, adjustable volume, firmer feel than silicone",
                    treatment: "Inserted empty and filled during surgery for precise sizing"
                  },
                  {
                    type: "Gummy Bear Implants",
                    description: "Form-stable cohesive silicone gel that holds shape even when cut",
                    treatment: "Teardrop shape for natural contour, minimal risk of leakage"
                  },
                  {
                    type: "Round Implants",
                    description: "Symmetrical shape that provides fullness in upper breast pole",
                    treatment: "Consistent results regardless of rotation, various projection options"
                  },
                  {
                    type: "Smooth Surface Implants",
                    description: "Soft natural movement, may rotate without affecting shape",
                    treatment: "Lower risk of visible rippling, develops soft capsule"
                  },
                  {
                    type: "Textured Surface Implants",
                    description: "Rough surface that adheres to tissue, reduces risk of rotation",
                    treatment: "Helps prevent capsular contracture, maintains implant position"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Women with fully developed breasts (18+ for saline, 22+ for silicone)</li>
                      <li style={{ marginBottom: "10px" }}>Those seeking to enhance breast size and shape</li>
                      <li style={{ marginBottom: "10px" }}>Women with asymmetrical breasts</li>
                      <li style={{ marginBottom: "10px" }}>Post-pregnancy volume restoration candidates</li>
                      <li>Breast reconstruction after mastectomy</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about outcomes</li>
                      <li style={{ marginBottom: "10px" }}>Good overall health with no active infections</li>
                      <li style={{ marginBottom: "10px" }}>Non-smokers or willing to quit before and after surgery</li>
                      <li style={{ marginBottom: "10px" }}>Understanding of potential risks and complications</li>
                      <li>Stable weight for at least 6 months</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Surgical Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Implant Placement Options
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    The placement of breast implants significantly affects the final appearance, 
                    recovery time, and potential complications. Each approach has distinct advantages.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Placement Techniques:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Submuscular:</strong> Under chest muscle, more natural look, lower capsular contracture risk</li>
                          <li style={{ marginBottom: "8px" }}><strong>Subglandular:</strong> Over muscle, shorter recovery, more dramatic results</li>
                          <li style={{ marginBottom: "8px" }}><strong>Dual Plane:</strong> Combination approach, optimal for breast augmentation with lift</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Incision Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>Inframammary:</strong> In breast fold, most common, excellent visibility</li>
                      <li style={{ marginBottom: "8px" }}><strong>Periareolar:</strong> Around nipple, scar blends with areola border</li>
                      <li style={{ marginBottom: "8px" }}><strong>Transaxillary:</strong> Through armpit, no breast scarring</li>
                      <li><strong>TUBA:</strong> Through belly button, rare but scar-free on breasts</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Fat Transfer Augmentation
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Natural Alternative:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Uses your own fat from other body areas</li>
                      <li style={{ marginBottom: "10px" }}>No implants, completely natural feel</li>
                      <li style={{ marginBottom: "10px" }}>Dual benefit of liposuction and breast enhancement</li>
                      <li style={{ marginBottom: "10px" }}>Small to moderate volume increase (typically 1-1.5 cup sizes)</li>
                      <li>Ideal for subtle enhancement and shaping</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Combination Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Breast augmentation with lift (mastopexy)</li>
                      <li style={{ marginBottom: "10px" }}>Mommy makeover packages</li>
                      <li style={{ marginBottom: "10px" }}>Breast reconstruction with implants</li>
                      <li style={{ marginBottom: "10px" }}>Revision augmentation for previous surgeries</li>
                      <li>Asymmetry correction procedures</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>3D imaging for preoperative planning</li>
                      <li style={{ marginBottom: "10px" }}>Precision measurements for ideal implant selection</li>
                      <li>Minimal scar approaches for optimal aesthetics</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Surgical bra wearing", "Pain management", "Limited arm movement", "Drain care if placed"]
                  },
                  {
                    period: "Week 3-4",
                    title: "Early Healing",
                    activities: ["Gradual return to light activities", "Swelling reduction", "Suture removal if needed", "Gentle massage"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Settling Phase",
                    activities: ["Implants settle into position", "Most swelling resolves", "Return to exercise", "Scar care begins"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Final Results",
                    activities: ["Final breast shape visible", "Scars mature and fade", "Unrestricted activities", "Follow-up appointments"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Maintenance
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Wear surgical bra 24/7 for first 2-4 weeks</li>
                      <li style={{ marginBottom: "10px" }}>Sleep on back with elevated upper body</li>
                      <li style={{ marginBottom: "10px" }}>Avoid heavy lifting and strenuous activities for 4-6 weeks</li>
                      <li>Take prescribed medications and attend all follow-up visits</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Maintenance</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular self-examinations and annual check-ups</li>
                      <li style={{ marginBottom: "10px" }}>MRI screenings for silicone implants as recommended</li>
                      <li style={{ marginBottom: "10px" }}>Scar management with silicone sheets or creams</li>
                      <li>Maintain stable weight for consistent results</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is breast augmentation surgery?",
                  answer: "Breast augmentation is performed under general anesthesia, so you won't feel any pain during the procedure. After surgery, most patients describe the discomfort as moderate and manageable with prescribed pain medication. The first 2-3 days typically involve the most discomfort, characterized by tightness, swelling, and soreness in the chest area. Many patients compare the feeling to an intense workout in the chest muscles. By the end of the first week, most discomfort subsides significantly, and over-the-counter pain relievers are usually sufficient. Your surgeon will provide detailed pain management instructions and medications to ensure your comfort throughout the recovery process. Most patients return to light activities within 3-5 days and report that the results are well worth the temporary discomfort."
                },
                {
                  question: "How long do breast implants last?",
                  answer: "Modern breast implants are designed to be long-lasting, but they are not considered lifetime devices. The average lifespan of breast implants is typically 10-20 years, though many women have their original implants for much longer without issues. Saline and silicone implants both have excellent longevity, but may require replacement due to various factors: Rupture or deflation (more noticeable with saline), Capsular contracture (scar tissue hardening), Position changes or sagging over time, Personal preference for size change, and Routine maintenance after 10-15 years. Regular monitoring with your surgeon and following recommended MRI screenings for silicone implants (typically every 2-3 years after the first 5-6 years) helps ensure early detection of any issues. Many women never need replacement surgery if no complications arise."
                },
                {
                  question: "What is the recovery time for breast augmentation?",
                  answer: "Recovery from breast augmentation follows a predictable timeline: First 24-48 hours require rest with limited arm movement; Days 3-7 see significant improvement with return to light activities and desk work; Week 2 allows driving and light household tasks; Weeks 3-4 permit gradual return to light exercise (lower body only); Weeks 4-6 mark return to upper body exercises and more strenuous activities; 2-3 months for implants to fully settle into final position; 6 months for complete healing and final results. Most patients take 3-7 days off work, depending on their job requirements. Strenuous activities and heavy lifting should be avoided for 4-6 weeks. Following your surgeon's specific post-operative instructions is crucial for optimal healing and results. The recovery experience varies based on implant placement (submuscular typically has longer initial recovery) and individual healing factors."
                },
                {
                  question: "Can I breastfeed after breast augmentation?",
                  answer: "Most women can successfully breastfeed after breast augmentation surgery. The ability to breastfeed depends on several factors: Incision location (periareolar incisions have slightly higher risk of affecting milk ducts), Implant placement (subglandular typically preserves more glandular tissue), Surgical technique and care to preserve milk ducts and nerves, and Individual anatomy and surgical outcomes. Studies show that the majority of women with breast implants can breastfeed successfully. However, some women may experience: Reduced milk supply in some cases, Changes in nipple sensation that could affect let-down reflex, and Need for additional lactation support. If you plan to have children in the future, discuss this with your surgeon during consultation. They can recommend surgical approaches that maximize preservation of breastfeeding capability. Many women with implants successfully breastfeed their children without complications."
                },
                {
                  question: "What's the difference between silicone and saline implants?",
                  answer: "Silicone and saline implants offer different benefits and considerations: Silicone implants contain a cohesive gel that closely mimics natural breast tissue, providing a more natural feel and movement. They are pre-filled and require a slightly longer incision. Modern silicone implants are form-stable and highly durable. Saline implants are filled with sterile salt water during surgery, allowing for minor size adjustments. They feel slightly firmer than silicone and may show more rippling in thin patients. If ruptured, saline is harmlessly absorbed by the body, making rupture immediately apparent. Key differences include: Natural feel (silicone feels more natural), Rupture detection (saline deflation is obvious, silicone requires MRI), Incision size (saline can use smaller incisions), Cost (saline is typically less expensive), and FDA recommendations (silicone requires periodic MRI monitoring). Your surgeon will help you choose based on your body type, goals, and personal preferences during consultation."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Breast Augmentation?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert surgical team provides personalized breast augmentation with natural results and comprehensive care.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Plastic Surgery: <strong>080-6541-7705</strong> | Cosmetic Surgery: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BreastAugmentationSurgery;